module.exports = __webpack_public_path__ + "img/1.77483e28.png";